/* Silicium IA — thème + animations */
(function () {
    var KEY = 'silicium-theme';

    function applyTheme(t) {
        var root = document.documentElement;
        var dark = (t === 'dark');

        root.setAttribute('data-theme', t);

        // Synchronise la variable lue par le script de contraste de Ghost
        root.style.setProperty('--background-color', dark ? '#0b0f19' : '#ffffff');

        // Remplace la classe de contraste calculée par Ghost au chargement
        root.classList.remove('has-light-text', 'has-dark-text');
        root.classList.add(dark ? 'has-light-text' : 'has-dark-text');

        try { localStorage.setItem(KEY, t); } catch (e) {}

        syncLabels();
    }

    // Met à jour l'icône/libellé des boutons de bascule ([data-theme-icon]/[data-theme-label])
    function syncLabels() {
        var dark = document.documentElement.getAttribute('data-theme') === 'dark';
        document.querySelectorAll('[data-theme-icon]').forEach(function (el) {
            el.textContent = dark ? '🌙' : '☀️';
        });
        document.querySelectorAll('[data-theme-label]').forEach(function (el) {
            el.textContent = dark ? 'Sombre' : 'Clair';
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        syncLabels();

        // Boutons de bascule clair/sombre (un sur mobile, un sur desktop)
        var btns = document.querySelectorAll('[data-theme-toggle]');
        if (btns.length) {
            btns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var cur = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
                    applyTheme(cur === 'dark' ? 'light' : 'dark');
                });
            });
        }

        // Révélation au scroll (micro-animations)
        var els = document.querySelectorAll('.reveal');
        if (els.length && 'IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (e) {
                    if (e.isIntersecting) {
                        e.target.classList.add('is-visible');
                        io.unobserve(e.target);
                    }
                });
            }, { threshold: 0.1 });
            els.forEach(function (el) { io.observe(el); });
        } else {
            els.forEach(function (el) { el.classList.add('is-visible'); });
        }
    });
})();
